import React, {Component} from "react";
import ErrorSpan from "../ErrorSpan";
import $ from 'jquery';

const uniqid = require('uniqid');

const APPLICATION_STATUS_NEW = 1;

export default class UploadStep extends Component {
    constructor() {
        super(...arguments);

        this.state = {
            join_ecp_documents: [],
            join_scan_documents: [],
            passport_documents: [],
            ipn_documents: [],
            ownership_documents: [],
            errors: {}
        }

        this.join_ecp_ref = React.createRef();
        this.join_scan_ref = React.createRef();
        this.passport_ref = React.createRef();
        this.ipn_ref = React.createRef();
        this.ownership_ref = React.createRef();

        this.submit = this.submit.bind(this);
        this.generateConnectionPdf = this.generateConnectionPdf.bind(this);
    }

    handleAddFile(type, file) {
        let files = this.state[type];
        files.push({file: file, id: uniqid()});

        this.setState(prevState => ({
            ...prevState,
            [type]: files
        }))
    }

    handleDeleteFile(type, index) {
        let files = this.state[type];
        files.splice(index, 1);

        this.setState(prevState => ({
            ...prevState,
            [type]: files
        }))
    }

    appendDocument(formData, key, documents) {
        for (let i = 0; i < documents.length; i++) {
            let file = documents[i].file;
            formData.append(`${key}[${documents[i].id}]`, file);
        }

        return formData;
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip()
    }

    submit() {
        let formData = new FormData();
        formData.append('application_id', this.props.applicationId);
        formData = this.appendDocument(formData, 'join_ecp_document', this.state.join_ecp_documents);
        formData = this.appendDocument(formData, 'join_scan_document', this.state.join_scan_documents);
        formData = this.appendDocument(formData, 'passport_document', this.state.passport_documents);
        formData = this.appendDocument(formData, 'ipn_document', this.state.ipn_documents);
        formData = this.appendDocument(formData, 'ownership_document', this.state.ownership_documents);

        axios.post('/gas/upload-documents', formData)
            .then((resp) => {
                this.props.moveNext();
            })
            .catch((error) => {
                this.setState({
                    errors: error.response.data.errors || {}
                })
            })
    }

    generateConnectionPdf() {
        axios.get(`/gas/generate-connection-pdf/${this.props.applicationId}`)
            .then((resp) => {
                window.open(resp.data.url, '_blank');
            })
            .catch((error) => {
                let {errors} = this.state;
                errors.generate_pdf = window.translates.add_docs.generate_pdf_request_error;

                this.setState({errors: errors});
            })
    }

    render() {
        const {applicationStatus, fullName, phoneNumber, address, needDocuments} = this.props;
        const {
            join_ecp_documents,
            join_scan_documents,
            passport_documents,
            ipn_documents,
            ownership_documents,
            errors
        } = this.state;
        const disabledSubmitButton = (!join_scan_documents.length && !join_ecp_documents.length) && +applicationStatus === APPLICATION_STATUS_NEW;

        return (
            <div className="upload-documents">
                <div className="top-block">
                    <div className="row justify-content-between">
                        <div className="col-md-5">
                            <div className="header">{window.translates.add_docs.header_title}</div>
                        </div>
                        <div className="col-md-5">
                            <div className="header-info">

                            </div>
                        </div>
                    </div>
                </div>
                <div className="application-info-block">
                    <div className="header">{window.translates.add_docs.application_info_header}</div>
                    <div className="row align-items-center">
                        <div className="col-md-2 text-left">
                            {fullName}
                        </div>
                        <div className="col-md-2 text-center">
                            {phoneNumber}
                        </div>
                        <div className="col-md-4 text-center">
                            {address}
                        </div>
                        <div className="col-md-4 text-left">
                            <button className="btn btn-site btn-outline-dark"
                                    onClick={this.generateConnectionPdf}
                            >
                                {window.translates.add_docs.generate_pdf_button}
                            </button>
                            {errors.generate_pdf && <ErrorSpan error={errors.generate_pdf}/>}
                        </div>
                    </div>
                </div>
                <div className="files-block">
                    <div className="row">
                        <div className="col-md-5">
                            <b>
                                {window.translates.add_docs.files.join_ecp.title}
                                {needDocuments.join_ecp_document &&
                                <i className="fa fa-exclamation-circle text-info cursor-pointer ml-1" style={{fontSize: '14px'}}
                                   data-toggle="tooltip" data-placement="top"
                                   title="Вам потрібно завантажити цей документ"/>
                                }
                            </b>
                            {errors.join_ecp_document &&
                            <ErrorSpan error={errors.join_ecp_document}/>
                            }
                            <p>{window.translates.add_docs.files.join_ecp.info}</p>
                            <p className="mt-5">{window.translates.add_docs.files.join_ecp.info_1}</p>
                            {join_ecp_documents &&
                            join_ecp_documents.map((file, index) => {
                                return (
                                    <div key={index}>
                                        <p className="text-info" key={file.id}>
                                            {file.file.name} <i className="remove-icon text-danger"
                                                                onClick={() => this.handleDeleteFile('join_ecp_documents', index)}/>
                                        </p>
                                        {errors[`join_ecp_document.${file.id}`] &&
                                        <ErrorSpan error={errors[`join_ecp_document.${file.id}`]}/>
                                        }
                                    </div>
                                )
                            })
                            }
                            <div className="d-flex mt-2">
                                <input type='file' ref={this.join_ecp_ref} style={{display: 'none'}}
                                       accept="application/pdf,image/jpg,image/jpeg,image/png,.zip,.doc,.docx,.p7s"
                                       onChange={(e) => this.handleAddFile('join_ecp_documents', e.target.files[0])}
                                />
                                <button className="btn btn-site btn-outline-dark mr-2"
                                        onClick={() => this.join_ecp_ref.current.click()}
                                >
                                    {window.translates.add_docs.files.join_ecp.upload_button}
                                </button>
                                {/*<button className="btn btn-site btn-outline-dark">Де взяти КЕП</button>*/}
                            </div>
                        </div>

                        <div className="col-md-2 text-center">
                            <b>– {window.translates.add_docs.or} –</b>
                        </div>

                        <div className="col-md-5">
                            <b>
                                {window.translates.add_docs.files.join_scan.title}
                                {needDocuments.join_scan_document &&
                                <i className="fa fa-exclamation-circle cursor-pointer text-info ml-1" style={{fontSize: '14px'}}
                                   data-toggle="tooltip" data-placement="top"
                                   title="Вам потрібно завантажити цей документ"/>
                                }
                            </b>
                            {errors.join_scan_document &&
                            <ErrorSpan error={errors.join_scan_document}/>
                            }
                            <p>{window.translates.add_docs.files.join_scan.info}</p>
                            {join_scan_documents &&
                            join_scan_documents.map((file, index) => {
                                return (
                                    <p className="text-info" key={file.id}>
                                        {file.file.name} <i className="remove-icon text-danger"
                                                            onClick={() => this.handleDeleteFile('join_scan_documents', index)}/>
                                    </p>
                                )
                            })
                            }
                            <input type='file' ref={this.join_scan_ref} style={{display: 'none'}}
                                   accept="application/pdf,image/jpg,image/jpeg,image/png,.zip,.doc,.docx,.p7s"
                                   onChange={(e) => this.handleAddFile('join_scan_documents', e.target.files[0])}
                            />
                            <button className="btn btn-site btn-outline-dark mt-4"
                                    onClick={() => this.join_scan_ref.current.click()}
                            >
                                {!join_scan_documents.length ? window.translates.add_docs.files.join_scan.upload_button : window.translates.add_docs.upload_more_button}
                            </button>
                        </div>
                        <div className="col-md-4 mt-5">
                            <b>
                                {window.translates.add_docs.files.passport.title}
                                {needDocuments.passport_document &&
                                <i className="fa fa-exclamation-circle cursor-pointer text-info ml-1" style={{fontSize: '14px'}}
                                   data-toggle="tooltip" data-placement="top"
                                   title="Вам потрібно завантажити цей документ"/>
                                }
                            </b>
                            {errors.passport_document &&
                            <ErrorSpan error={errors.passport_document}/>
                            }
                            <p>{window.translates.add_docs.files.passport.info}</p>
                            {passport_documents &&
                            passport_documents.map((file, index) => {
                                return (
                                    <p className="text-info" key={file.id}>
                                        {file.file.name} <i className="remove-icon text-danger"
                                                            onClick={() => this.handleDeleteFile('passport_documents', index)}/>
                                    </p>
                                )
                            })
                            }
                            <input type='file' ref={this.passport_ref} style={{display: 'none'}}
                                   accept="application/pdf,image/jpg,image/jpeg,image/png,.zip,.doc,.docx,.p7s"
                                   onChange={(e) => this.handleAddFile('passport_documents', e.target.files[0])}
                            />
                            <button className="btn btn-site btn-outline-dark mt-4"
                                    onClick={() => this.passport_ref.current.click()}
                            >
                                {!passport_documents.length ? window.translates.add_docs.upload_button : window.translates.add_docs.upload_more_button}
                            </button>
                        </div>

                        <div className="col-md-4 mt-5">
                            <b>
                                {window.translates.add_docs.files.ipn.title}
                                {needDocuments.ipn_document &&
                                <i className="fa fa-exclamation-circle cursor-pointer text-info ml-1" style={{fontSize: '14px'}}
                                   data-toggle="tooltip" data-placement="top"
                                   title="Вам потрібно завантажити цей документ"/>
                                }
                            </b>
                            {errors.ipn_document &&
                            <ErrorSpan error={errors.ipn_document}/>
                            }
                            <p>{window.translates.add_docs.files.ipn.info}</p>
                            {ipn_documents &&
                            ipn_documents.map((file, index) => {
                                return (
                                    <p className="text-info" key={file.id}>
                                        {file.file.name} <i className="remove-icon text-danger"
                                                            onClick={() => this.handleDeleteFile('ipn_documents', index)}/>
                                    </p>
                                )
                            })
                            }
                            <input type='file' ref={this.ipn_ref} style={{display: 'none'}}
                                   accept="application/pdf,image/jpg,image/jpeg,image/png,.zip,.doc,.docx,.p7s"
                                   onChange={(e) => this.handleAddFile('ipn_documents', e.target.files[0])}
                            />
                            <button className="btn btn-site btn-outline-dark mt-4"
                                    onClick={() => this.ipn_ref.current.click()}
                            >
                                {!ipn_documents.length ? window.translates.add_docs.upload_button : window.translates.add_docs.upload_more_button}
                            </button>
                        </div>

                        <div className="col-md-4 mt-5">
                            <b>
                                {window.translates.add_docs.files.ownership.title}
                                {needDocuments.ownership_document &&
                                    <i className="fa fa-exclamation-circle cursor-pointer text-info ml-1" style={{fontSize: '14px'}}
                                    data-toggle="tooltip" data-placement="top"
                                    title="Вам потрібно завантажити цей документ"/>
                                }
                            </b>
                            {errors.ownership_document &&
                            <ErrorSpan error={errors.ownership_document}/>
                            }
                            <p>{window.translates.add_docs.files.ownership.info}</p>
                            {ownership_documents &&
                            ownership_documents.map((file, index) => {
                                return (
                                    <p className="text-info" key={file.id}>
                                        {file.file.name} <i className="remove-icon text-danger"
                                                            onClick={() => this.handleDeleteFile('ownership_documents', index)}/>
                                    </p>
                                )
                            })
                            }
                            <input type='file' ref={this.ownership_ref} style={{display: 'none'}}
                                   accept="application/pdf,image/jpg,image/jpeg,image/png,.zip,.doc,.docx,.p7s"
                                   onChange={(e) => this.handleAddFile('ownership_documents', e.target.files[0])}
                            />
                            <button className="btn btn-site btn-outline-dark mt-4"
                                    onClick={() => this.ownership_ref.current.click()}
                            >
                                {!ownership_documents.length ? window.translates.add_docs.upload_button : window.translates.add_docs.upload_more_button}
                            </button>
                        </div>
                    </div>
                    <button className="btn btn-site btn-secondary mt-5" disabled={disabledSubmitButton}
                            onClick={this.submit}
                    >
                        {window.translates.add_docs.submit_button}
                    </button>
                </div>
            </div>
        )
    }
}
